import PropTypes from 'prop-types';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { PATH_DASHBOARD } from '@/routes/paths';
import LoadingScreen from '@/components/loading-screen';
import { useSessionContext } from './useSessionContext';

// ---------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard({ children }) {
  const { isAuthenticated, SSOLoginURL, isInitialized } = useSessionContext()
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const localStorageNextParam = localStorage.getItem('next');
  const nextParam = searchParams.get('next') || localStorageNextParam;

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (location.pathname === '/auth/login') {
      window.location.href = SSOLoginURL
    }
  } else {
    return (
      <Navigate
        to={nextParam && !nextParam.startsWith('/auth') ? `/${nextParam.replace(/^\/+/, '')}` : PATH_DASHBOARD.general.home}
      />
    );
  }

  return <> {children} </>;
}
